function kkhybrid_linkdesk (opt) {
  hybrid({
    hybridParam: {
        schema: "kkhybrid",
        tagname: "linkDesk",
    },
    param: {
      name: opt.name,
      icon: opt.icon,
      link: opt.link
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

function kkmhhybrid_linkdesk (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "linkDesk",
    },
    param: {
      name: opt.name,
      icon: opt.icon,
      link: opt.link
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}


/**
 * 发送快捷方式到桌面<br>
 * kkhybrid://linkDesk，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=7111336}<br>
 * kkmhhybrid://linkDesk，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=301893146}<br>
 * @param {Object} opt 参数对象
 * @param {String} opt.name 快捷方式名称
 * @param {String} opt.icon 快捷方式图标链接
 * @param {String} opt.link 快捷方式链接地址
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置）
 */
function linkDesk (opt) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion);
  if(allow) {
    // 调用新协议
    kkmhhybrid_linkdesk(opt);
  } else {
    // 调用旧协议
    kkhybrid_linkdesk(opt);
  }
}

export default linkDesk;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/linkDesk/index.js